import React from 'react'
// eslint-disable-next-line import/named
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon'

export const IconImagesLeft: React.FC<SvgIconProps> = ({sx}) => (
  <SvgIcon
    viewBox="0 0 22 49"
    sx={{
      width: 22, 
      height: 49,
      ...sx,
    }}
  >
    <rect opacity="0.25" width="22" height="49" rx="8" fill="white"/>
    <path 
        d="M15 33.4292V14.5708C15 13.6588 13.8791 13.2228 13.2628 13.8951L4.61941 23.3243C4.26895 23.7066 4.26895 24.2934 4.61941 24.6757L13.2628 34.1049C13.8791 34.7772 15 34.3412 15 33.4292Z" 
        // stroke="none"
        opacity="0.25"
        fill="#D4E8F1"
    />
  </SvgIcon>
)
